import React from 'react'

import {DNDPreviewLayerProps} from "./dnd-preview-layer-component"

export type DndPreviewLayerComponent_State = {
    source: any
}

export default class DndPreviewLayerComponent_V2<P extends DNDPreviewLayerProps, S extends DndPreviewLayerComponent_State> extends React.Component<P, S> {

    protected initialPreviewSourceRect: any
    protected previewNode: any

    static defaultProps = {
        dndLayerName: 'default'
    }

    constructor(props: P) {
        super(props);

        // We cast the initial state as Readonly<S> because React expects the `state` property to be read-only outside of setState().
        // This enforces immutability of the state object, preventing accidental mutation and ensuring predictable state updates.
        this.state = {
            source: null
        } as Readonly<S>
    }

    componentDidMount() {
        this.dndManager?.registerDndLayer(this, this.props.dndLayerName)
    }

    componentWillUnmount() {
        this.dndManager?.unregisterDndLayer(this, this.props.dndLayerName)
    }

    get dndManager() {
        return this.props.dndManager
    }

    showPreview(source: any, mouseEvent: MouseEvent) {
        //should be overridden
    }

    hidePreview() {
        //should be overridden
    }

    updatePreview(dx = 0, dy = 0) {
        //should be overridden
    }

    render(): React.ReactNode {
        return (
            <div className="gd-dnd-layer"/>
        )
    }
}